import request from "@/service";

// 期刊栏目列表
export function subjectList(id) {
  return request({
    url: `/resource/periodical/subject/list/${id}`,
    method: "get"
  });
}

// 期刊栏目详情
export function subjectInfo(id) {
  return request({
    url: `/resource/periodical/subject/info/${id}`,
    method: "get"
  });
}

/* 新增 */
export function subjectSave(data) {
  return request({
    url: `/resource/periodical/subject/save`,
    method: "post",
    data
  });
}

/* 修改 */
export function subjectUpdate(data) {
  return request({
    url: `/resource/periodical/subject/update`,
    method: "put",
    data
  });
}

/* 删除 */
export function subjectDelete(data) {
  return request({
    url: `/resource/periodical/subject/delete`,
    method: "delete",
    data
  });
}

/* 拖拽*/
export function subjectOrderByDrag(data) {
  return request({
    url: `/resource/periodical/subject/orderByDrag`,
    method: "put",
    data
  });
}
